import * as React from 'react'
import { useHistory } from 'react-router'
import * as ContentActions from '../../../../actions/content'
import { useAppDispatch } from '../../../../actions/types'
import { useAppSelector } from '../../../../reducers'
import type { ExtendedChannel } from '../types'
import useContentURLParams from './useContentURLParams'
import { Routes } from '../../../../constants'
import useChannelsFiltersParams from '../ChannelsSubBar/ChannelsFilters/useChannelsFiltersParams'

export default function useChannels(): ExtendedChannel[] {
    const dispatch = useAppDispatch()
    const channels = useAppSelector<ExtendedChannel[]>(state => state.content.channels)
    const savedEstate = useAppSelector<string>(state => state.app.selectedEstate)
    const { searchChannel, selectedEstate } = useContentURLParams()
    const [filtersParams] = useChannelsFiltersParams()
    const history = useHistory()
    
    // Initial fetch of the channels list
    React.useEffect(() => {
        const { chains } = filtersParams

        // Use the current search string if any
        dispatch(ContentActions.fetchChannels(null, { chains, name: searchChannel }))
    }, [dispatch, filtersParams, searchChannel])

    // Look for any estate change. If it happens, make sure it goes to the root channel list,
    // deselecting any selected channel and playlist. It also discards any active search
    React.useEffect(() => {
        if (savedEstate && savedEstate !== selectedEstate) {
            const redirectTo = Routes.buildRoute(Routes.CONTENT, {
                estate: selectedEstate,
            })

            // Redirect to the root section
            history.replace(redirectTo)

            // Fetch channel list in the new estate
            dispatch(ContentActions.fetchChannels())
        }
    }, [dispatch, history, savedEstate, selectedEstate])

    return channels
}